export const Path = {
  HOME: '/',
  SETTINGS: '/settings',
  LOGIN: '/login',
  EPIC: '/epic',
  RESOURCE: '/resource',
  STORY: '/story',
  TESTS: '/tests',
};
